import React from 'react';

const JoyConShoulder = props => (
  <svg
    className="joy-con-shoulder"
    width={500}
    height={121}
    viewBox="0 0 500 121"
    fill="none"
    {...props}
  >
    <path
      d="M11.4299 44.3987C11.4299 34.3315 20.6696 18.2084 21.8597 5.50781C21.8597 2.81802 24.57 1 26.6327 1H35.6483C38.6411 1 40.8984 5.33102 43.5149 5.33102V39.1838L11.4299 44.3987Z"
      fill="#44484C"
      stroke="black"
    />
    <path
      d="M34.3563 1.16187C34.3563 19.8913 28.4813 23.3025 28.4813 28.2869"
      stroke="black"
    />
    <path
      d="M7.05466 57.1708C7.05466 57.1708 6.91991 78.2433 7.05466 78.2072C7.18941 78.1711 2.8562 78.2072 2.8562 78.2072C1.72854 78.2072 1.00006 77.3716 1.00006 76.3511L1.00006 59.1595C1.00006 57.9426 2.08835 57.1708 2.9888 57.1708H7.05466Z"
      fill="#44484C"
      stroke="black"
    />
    <path
      d="M94.5638 89.6951C95.3431 92.4946 100.722 97.7264 106.094 98.9448C106.094 100.538 105.158 102.746 103.221 102.746H84.748C80.8574 102.746 81.8364 115.4 88.1388 115.4H94.5149C107.762 120.844 119.593 120.955 132.522 115.4H139.239C145.092 115.4 146.297 102.861 142.599 102.861H124.479C121.851 102.861 120.621 101.023 120.775 99.1573C125.491 97.2041 129.702 94.6449 132.08 89.885V88.1173H94.5481L94.5638 89.6951Z"
      fill="#44484C"
      stroke="black"
    />
    <path
      d="M298.411 71.0735V94.8235C298.411 95.3758 298.859 95.8235 299.411 95.8235H322.536C323.088 95.8235 323.536 95.3758 323.536 94.8235V71.0735C323.536 70.5212 323.088 70.0735 322.536 70.0735H299.411C298.859 70.0735 298.411 70.5212 298.411 71.0735Z"
      fill="#44484C"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M277.492 89.7132C277.492 89.89 277.492 94.0442 277.492 94.0442C277.492 95.8523 276.388 96.5633 274.973 96.5633C267.346 97.2359 258.08 97.1964 250.268 96.5633C248.955 96.5633 247.668 95.3153 247.683 93.9779V88.6968H277.492V89.7132Z"
      fill="#44484C"
      stroke="black"
    />
    <path
      d="M43.536 73.8858V94.1288C43.536 94.6657 43.9713 95.101 44.5082 95.101H48.9387C49.4757 95.101 49.911 94.6657 49.911 94.1288V73.8858C49.911 73.3488 49.4757 72.9135 48.9387 72.9135H44.5082C43.9713 72.9135 43.536 73.3488 43.536 73.8858Z"
      fill="#44484C"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.4813 26.0369V33.0369H46.7313V25.9119C46.7313 24.9908 47.5368 24.5751 48.2625 24.3806C53.4988 22.9776 59.1353 23.0487 64.1063 24.3806C64.89 24.5906 65.4813 25.1166 65.4813 26.0369Z"
      fill="#44484C"
      stroke="black"
    />
    <path
      d="M214.913 89.7132C214.913 89.89 214.913 94.0442 214.913 94.0442C214.913 95.8523 213.809 96.5633 212.394 96.5633C204.767 97.2359 195.501 97.1964 187.689 96.5633C186.376 96.5633 185.089 95.3153 185.104 93.9779V88.6968H214.913V89.7132Z"
      fill="#44484C"
      stroke="black"
    />
    <path
      d="M246.202 89.7132C246.202 89.89 246.202 94.0442 246.202 94.0442C246.202 95.8523 245.099 96.5633 243.683 96.5633C236.056 97.2359 226.79 97.1964 218.979 96.5633C217.666 96.5633 216.379 95.3153 216.393 93.9779V88.6968H246.202V89.7132Z"
      fill="#44484C"
      stroke="black"
    />
    <path
      d="M96.4813 32.4744C77.2512 32.4744 63.56 8.95172 45.7938 1.09937C44.0879 0.642295 42.1063 1.99138 42.1063 3.66187V13.5994C42.1063 28.9519 24.4605 25.7892 16.6063 36.0369L96.5037 36.0369L96.4813 32.4744Z"
      fill="#747474"
      stroke="black"
    />
    <path
      d="M5.94977 53.8562L5.94977 75.4496C5.94977 83.7304 14.0806 89.3883 21.5061 89.3883L408.47 89.3883C417.185 89.3883 423.761 82.4193 423.761 74.0971V54.5633C423.761 42.3226 411.212 31.6265 400.825 31.6265L28.2236 31.6265C16.9976 31.6265 5.94977 44.4987 5.94977 53.8562V53.8562Z"
      fill="#747474"
      stroke="black"
    />
    <path
      d="M28.3791 75.8445L28.3791 45.7292C28.3791 43.373 30.2892 41.4629 32.6454 41.4629L377.465 41.4629C379.821 41.4629 381.731 43.373 381.731 45.7292V75.8445C381.731 78.2007 379.821 80.1108 377.465 80.1108L32.6454 80.1108C30.2892 80.1108 28.3791 78.2007 28.3791 75.8445Z"
      fill="#44484C"
      stroke="black"
    />
    <path
      d="M316.606 71.3955V49.9281C316.606 47.5719 318.516 45.6618 320.873 45.6618H373.465C375.821 45.6618 377.731 47.5719 377.731 49.9281V71.3955C377.731 73.7517 375.821 75.6618 373.465 75.6618H320.873C318.516 75.6618 316.606 73.7517 316.606 71.3955Z"
      fill="#2E2F31"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M374.12 60.5992L358.506 51.5847V69.6138L374.12 60.5992Z"
      fill="#44484C"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M355.432 60.5992L339.819 51.5847V69.6138L355.432 60.5992Z"
      fill="#44484C"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M336.745 60.5992L321.131 51.5847V69.6138L336.745 60.5992Z"
      fill="#44484C"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M161.481 62.2705V58.9281C161.481 57.8145 162.384 56.9118 163.498 56.9118H166.84C167.953 56.9118 168.856 57.8145 168.856 58.9281V62.2705C168.856 63.3841 167.953 64.2868 166.84 64.2868H163.498C162.384 64.2868 161.481 63.3841 161.481 62.2705Z"
      fill="#AAEEFF"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M177.856 62.2705V58.9281C177.856 57.8145 178.759 56.9118 179.873 56.9118H183.215C184.328 56.9118 185.231 57.8145 185.231 58.9281V62.2705C185.231 63.3841 184.328 64.2868 183.215 64.2868H179.873C178.759 64.2868 177.856 63.3841 177.856 62.2705Z"
      fill="#AAEEFF"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.606 62.2705V58.9281C194.606 57.8145 195.509 56.9118 196.623 56.9118H199.965C201.078 56.9118 201.981 57.8145 201.981 58.9281V62.2705C201.981 63.3841 201.078 64.2868 199.965 64.2868H196.623C195.509 64.2868 194.606 63.3841 194.606 62.2705Z"
      fill="#AAEEFF"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M210.981 62.2705V58.9281C210.981 57.8145 211.884 56.9118 212.998 56.9118H216.34C217.453 56.9118 218.356 57.8145 218.356 58.9281V62.2705C218.356 63.3841 217.453 64.2868 216.34 64.2868H212.998C211.884 64.2868 210.981 63.3841 210.981 62.2705Z"
      fill="#AAEEFF"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M103.439 102.695H122.814" stroke="black" />
    <path d="M105.942 98.8643H121.326" stroke="black" />
    <g filter="url(#filter0_f)">
      <path d="M94.6263 115.414H132.626" stroke="black" />
    </g>
    <path
      d="M268.731 62.8955V58.5531C268.731 55.5756 271.089 53.1618 273.998 53.1618H298.59C301.498 53.1618 303.856 55.5756 303.856 58.5531V62.8955C303.856 65.873 301.498 68.2868 298.59 68.2868H273.998C271.089 68.2868 268.731 65.873 268.731 62.8955Z"
      fill="#999595"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M286.025 60.4848V56.1589L287.914 56.1592C288.953 56.1593 289.962 56.1662 290.156 56.1725C291.426 56.2189 291.98 56.3919 292.46 56.8917C292.993 57.4476 293.215 58.3019 293.045 59.1504C292.95 59.6231 292.713 60.0391 292.357 60.3566C292.03 60.6483 291.504 60.8764 290.948 60.9682C290.824 60.9885 290.811 60.9933 290.834 61.0091C290.848 61.0191 290.95 61.0866 291.06 61.1596C291.523 61.4657 291.787 61.7267 292.161 62.2477C292.377 62.55 292.474 62.7004 293.188 63.8403L293.791 64.8041L292.76 64.8071C291.947 64.8091 291.727 64.807 291.714 64.7938C291.705 64.7848 291.362 64.2745 290.95 63.6604C289.761 61.8865 289.613 61.6856 289.337 61.4753C289.063 61.2667 288.843 61.215 288.182 61.2036L287.764 61.1967V63.0036V64.8105H286.895H286.025V60.4848ZM289.943 59.8091C290.227 59.7933 290.478 59.7651 290.587 59.7368C290.914 59.6512 291.171 59.3964 291.268 59.0603C291.304 58.9349 291.319 58.6169 291.295 58.4778C291.238 58.1403 291.068 57.9053 290.779 57.7632C290.502 57.6268 290.374 57.6173 288.817 57.6168L287.764 57.6165V58.7197V59.8229L288.73 59.8229C289.261 59.8229 289.807 59.8158 289.943 59.8091Z"
      fill="black"
      stroke="black"
      strokeWidth={0.0133722}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M281.409 64.9679C280.087 64.8637 279.237 64.3999 278.701 63.4898C278.485 63.1246 278.295 62.5349 278.244 62.0736L278.235 61.9908L278.28 61.9828C278.364 61.9684 279.929 61.8208 279.935 61.8266C279.938 61.8296 279.953 61.893 279.969 61.9672C279.985 62.0414 280.023 62.175 280.052 62.2643C280.282 62.9559 280.715 63.338 281.411 63.4629C281.623 63.5011 282.089 63.5045 282.314 63.469C282.613 63.422 282.841 63.3446 283.02 63.2288C283.266 63.0699 283.45 62.8473 283.534 62.6085C283.582 62.4734 283.595 62.2023 283.561 62.0679C283.495 61.8041 283.336 61.6316 283.013 61.4741C282.787 61.3635 282.53 61.2863 281.562 61.0396C280.681 60.8149 280.324 60.6938 279.89 60.4723C279.475 60.2608 279.149 59.972 278.908 59.603C278.652 59.2105 278.533 58.7649 278.553 58.274C278.57 57.851 278.7 57.4588 278.94 57.102C279.116 56.8396 279.302 56.6548 279.57 56.4751C280.116 56.1089 280.838 55.9272 281.747 55.9274C282.76 55.9276 283.528 56.1314 284.095 56.5505C284.241 56.6588 284.472 56.8892 284.58 57.0358C284.873 57.4317 285.035 57.8768 285.081 58.4091C285.088 58.4908 285.091 58.5593 285.089 58.5614C285.083 58.5674 283.344 58.6437 283.339 58.6388C283.336 58.6358 283.323 58.581 283.309 58.5152C283.228 58.1441 283.065 57.8456 282.853 57.6786C282.689 57.5494 282.476 57.4621 282.205 57.413C281.988 57.3738 281.499 57.37 281.271 57.406C280.912 57.4621 280.619 57.5859 280.429 57.762C280.227 57.9487 280.169 58.2698 280.29 58.5282C280.345 58.6456 280.478 58.7842 280.615 58.867C280.87 59.0203 281.308 59.1668 282.106 59.3645C283.068 59.6031 283.616 59.7843 284.026 60.0002C284.691 60.3497 285.137 60.9297 285.278 61.6277C285.328 61.8807 285.343 62.0686 285.335 62.3574C285.329 62.5604 285.32 62.6507 285.293 62.7782C285.144 63.4822 284.728 64.0889 284.148 64.4499C283.739 64.704 283.218 64.8665 282.566 64.9434C282.391 64.964 281.579 64.981 281.409 64.9676L281.409 64.9679Z"
      fill="black"
      stroke="black"
      strokeWidth={0.0135255}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M99.8963 62.8955V58.5531C99.8963 55.5756 102.254 53.1618 105.163 53.1618H129.755C132.664 53.1618 135.021 55.5756 135.021 58.5531V62.8955C135.021 65.873 132.664 68.2868 129.755 68.2868H105.163C102.254 68.2868 99.8963 65.873 99.8963 62.8955Z"
      fill="#999595"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M112.913 65.0731C111.904 65.0117 111.144 64.7124 110.609 64.1657C110.211 63.7587 109.931 63.2013 109.797 62.5486C109.766 62.3994 109.722 62.1288 109.728 62.1248C109.73 62.1248 110.089 62.0888 110.526 62.0469C110.964 62.0051 111.345 61.9676 111.372 61.9636C111.416 61.9566 111.422 61.9596 111.422 61.9835C111.422 62.0304 111.474 62.2392 111.524 62.393C111.762 63.1249 112.243 63.516 113.013 63.6041C113.19 63.6244 113.644 63.6131 113.809 63.5844C114.245 63.5088 114.566 63.338 114.782 63.0684C114.951 62.8578 115.012 62.6859 115.012 62.4197C115.012 62.23 114.988 62.1243 114.916 61.9985C114.866 61.912 114.747 61.7922 114.643 61.7228C114.394 61.5574 114.146 61.4763 112.994 61.1825C112.273 60.9989 111.93 60.889 111.556 60.7225C111.05 60.497 110.683 60.1987 110.409 59.7902C110.258 59.5651 110.138 59.2751 110.082 58.9995C110.055 58.8685 110.052 58.8102 110.052 58.5418C110.052 58.2758 110.056 58.2166 110.082 58.1037C110.229 57.4432 110.642 56.889 111.228 56.5643C111.491 56.4184 111.832 56.2968 112.169 56.2283C112.91 56.0779 113.892 56.108 114.585 56.3025C114.904 56.3922 115.237 56.5461 115.474 56.7133C115.637 56.8283 115.922 57.1141 116.039 57.2782C116.225 57.5409 116.374 57.886 116.442 58.211C116.477 58.3753 116.504 58.5851 116.504 58.6883V58.749L116.427 58.7491C116.384 58.7492 116.016 58.7642 115.608 58.7825C115.199 58.8009 114.844 58.8159 114.818 58.8159H114.771L114.747 58.6989C114.694 58.4366 114.577 58.1744 114.444 58.0152C114.183 57.7052 113.799 57.5722 113.163 57.5724C112.745 57.5724 112.457 57.6287 112.178 57.7656C111.853 57.9244 111.721 58.0959 111.706 58.3763C111.695 58.585 111.745 58.7295 111.878 58.8752C112.091 59.1083 112.482 59.2625 113.528 59.5258C114.342 59.7307 114.652 59.823 115.053 59.9803C115.764 60.2598 116.22 60.6458 116.496 61.2028C116.661 61.536 116.734 61.8429 116.753 62.2859C116.775 62.8119 116.649 63.2951 116.37 63.7568C116.058 64.2729 115.575 64.6421 114.937 64.8528C114.38 65.0365 113.64 65.1171 112.913 65.0729L112.913 65.0731Z"
      fill="black"
      stroke="black"
      strokeWidth={0.0133722}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M119.049 60.6024V56.2608H119.928H120.807V59.8721V63.4834H123.005H125.203V64.2138V64.9442H122.126H119.049V60.6024Z"
      fill="black"
      stroke="black"
      strokeWidth={0.0135255}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="sync-button flash"
      d="M239.346 66.4603C240.924 66.4603 242.437 65.8333 243.553 64.7174C244.669 63.6015 245.296 62.088 245.296 60.5098C245.296 58.9316 244.669 57.4181 243.553 56.3022C242.437 55.1862 240.924 54.5593 239.346 54.5593C237.768 54.5593 236.254 55.1862 235.138 56.3022C234.022 57.4181 233.395 58.9316 233.395 60.5098C233.395 62.088 234.022 63.6015 235.138 64.7174C236.254 65.8333 237.768 66.4603 239.346 66.4603Z"
      fill="#2E2F31"
      stroke="black"
      strokeWidth={2.10067}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_f"
        x={92.7263}
        y={113.014}
        width={41.8}
        height={4.8}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation={0.95} result="effect1_foregroundBlur" />
      </filter>
    </defs>
  </svg>
);

export default JoyConShoulder;
